import { Pipe, PipeTransform } from '@angular/core';

/**
 * Facebook-style relative time in French: "à l'instant", "il y a 3 min", "il y a 2 h",
 * "il y a 3 j", "il y a 2 sem", then an absolute date for anything older.
 */
@Pipe({
  name: 'timeAgo',
  standalone: true,
  pure: false, // re-evaluates over time so "il y a 3 min" stays fresh as the view ticks
})
export class TimeAgoPipe implements PipeTransform {
  transform(value: string | number | Date | null | undefined): string {
    if (!value) {
      return '';
    }
    const date = value instanceof Date ? value : new Date(value);
    const ms = date.getTime();
    if (isNaN(ms)) {
      return '';
    }

    const diffSec = Math.floor((Date.now() - ms) / 1000);
    if (diffSec < 0) {
      return "à l'instant";
    }
    if (diffSec < 60) {
      return "à l'instant";
    }
    const min = Math.floor(diffSec / 60);
    if (min < 60) {
      return `il y a ${min} min`;
    }
    const hours = Math.floor(min / 60);
    if (hours < 24) {
      return `il y a ${hours} h`;
    }
    const days = Math.floor(hours / 24);
    if (days < 7) {
      return `il y a ${days} j`;
    }
    const weeks = Math.floor(days / 7);
    if (weeks < 5) {
      return `il y a ${weeks} sem`;
    }
    return date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
  }
}
